
















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { DiscountConfigWarpDto } from '../model/index'

@Component
export default class DiscountSetting extends Vue {
  @(Prop({
    type: Array,
    default: () => {
      items: [{ minDiscount: 0, maxDiscount: 0, direct: 0, indirect: 0 }]
    }
  })!)
  data: DiscountConfigWarpDto
  @(Prop({ type: Number, default: 1 })!) level: number

  add() {
    this.data.items.push({ minDiscount: 0, maxDiscount: 0, direct: 0, indirect: 0 })
  }
  removeItem(index: number) {
    this.data.items.splice(index, 1)
  }
}
